let store = null

export function getStore () {
  return store
}

export function setStore (arg) {
  store = arg
}
